// extracted by mini-css-extract-plugin
export default {"wrapper":"aBH01iWNmDiuLNaQ13ZY"};